export default __webpack_public_path__ + "static/media/LM-img.31d15b52.svg";